<script setup>
import FormButton from '@/components/Atoms/FormButton.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconPlus from '@/components/icon/IconPlus.vue'
import IconCamera from '@/components/icon/IconCamera.vue'
import IconWirelessSignal from '@/components/icon/IconWirelessSignal.vue'
import SubSecondRecommendedSettings from '@/components/SubSecondStream/SubSecondRecommendedSettings.vue'
import { showModal } from '@/Utils/modalBus'

defineProps({
	streamType: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<div>
		<div v-if="streamType !== 'subsecond'" class="flex flex-col items-center justify-center text-center py-10 lg:py-14">
			<div class="w-14 h-14 rounded-full bg-surface-3 flex items-center justify-center mb-4 text-surface-7">
				<icon-base width="26" height="26" :widthViewBox="24" :heightViewBox="24" fill="none">
					<icon-wireless-signal />
				</icon-base>
			</div>
			<p class="text-base font-medium !mb-1 text-surface-9">No destinations yet</p>
			<p class="text-surface-6 text-tiny !mb-6 max-w-xs">
				Connect platforms like YouTube, Facebook or Twitch — or any custom RTMP/SRT target — to start multistreaming.
			</p>
			<div class="flex flex-wrap items-center justify-center gap-2">
				<FormButton type="main" @click="showModal('modal-add-platform')">
					<icon-base class="mr-2" fill="none">
						<icon-plus />
					</icon-base>
					Add destination
				</FormButton>
				<FormButton v-if="streamType !== 'scheduled'" type="secondary" @click="showModal('modal-demo-video')">
					<icon-base class="mr-2" fill="none">
						<icon-camera />
					</icon-base>
					Watch demo
				</FormButton>
			</div>
		</div>
		<SubSecondRecommendedSettings v-else class="mt-5" />
	</div>
</template>
